<template>
	<div v-show="showResizeModal" class="resize-modal stack-vertical">
		<h1>Changed resolution</h1>
		<base-button type="variant3" text="restart" @clicked="reload"/>
	</div>
</template>

<script type="text/javascript">

// import { mapGetters } from 'vuex';

export default {
	name: 'InterfaceChangeRes',
	props: {
		showResizeModal: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {

		}
	},
	computed: {
		// ...mapGetters(['isMobile'])
	},
	methods: {
		reload() {
			location.reload();
		}
	}
}

</script>

<style type="text/css">
	.resize-modal {
		position: fixed;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		background-color: var(--color-white);
		align-items: center;
		justify-content: center;
		z-index: 100;
	}
</style>